const USER_ROL = {
  AGENT: 'agent',
  AGENT_SUPERVISOR: 'agent_supervisor',
  AUDITOR: 'agent_auditor',
};

Object.freeze(USER_ROL);

export default USER_ROL;
